import { t } from "@/i18n-js/instance";
import { useEnterpriseOfferEnabled } from "@/react/hooks/useEnterpriseOfferEnabled";
import { useUpgradePlanModal } from "@circle-react-shared/UpgradePlan";
import { UPGRADE_FLOW_SOURCES } from "@circle-react-shared/UpgradePlan/constants";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { BlueWrapper } from "./BlueWrapper";

export const EnterprisePriceIncrease = () => {
  const upgradePlanModal = useUpgradePlanModal();
  const { savingsAmount, enterprisePriceIncreaseDate } =
    useEnterpriseOfferEnabled();

  const handleUpgradeClick = async () => {
    await upgradePlanModal.show({
      planTier: "enterprise",
      source: UPGRADE_FLOW_SOURCES.ENTERPRISE_PRICE_INCREASE_BANNER,
      showPlanDetails: true,
    });
  };

  return (
    <BlueWrapper>
      <Typography.LabelLg weight="semibold" color="text-secondary">
        {t("pricing_plans.enterprise_price_increase_banner.title")}
      </Typography.LabelLg>
      <Typography.BodySm color="text-secondary">
        {t("pricing_plans.enterprise_price_increase_banner.description", {
          savingsAmount,
          enterprisePriceIncreaseDate,
        })}
      </Typography.BodySm>
      <div>
        <Button variant="secondary" onClick={handleUpgradeClick}>
          {t("pricing_plans.enterprise_price_increase_banner.button")}
        </Button>
      </div>
    </BlueWrapper>
  );
};
